/**
 * Rounds a decimal number to a specified number of decimal places. This way of handling precision allows
 * for avoiding the standard floating-point arithmetic issues in JavaScript.
 * @param decimal The decimal number to round.
 * @param precisionSlots The number of decimal places to keep.
 * @returns The rounded decimal number.
 */
export function precision(decimal: number, precisionSlots: number) {
  const f = Math.pow(10, precisionSlots);
  return Math.round(decimal * f) / f;
}

/**
 * Performs linear interpolation between two values. The higher the factor, the closer the result is to x1.
 * @param x0 The starting value.
 * @param x1 The ending value.
 * @param factor The interpolation factor (between 0 and 1).
 * @returns The interpolated value.
 */
export function lerp(x0: number, x1: number, factor: number): number {
  return precision(x0 + factor * (x1 - x0), 4);
}

export function midpoint(x0: number, x1: number): number {
  return lerp(x0, x1, 0.5);
}
